import { useEffect, useRef, useState } from 'react'

import { connect, useDataItem } from 'scrivito'

import { MessageAttachmentImageModal } from './MessageAttachmentImageModal'
import { MessageListItem } from './MessageListItem'
import { NewMessage } from './NewMessage'
import { MessageAttachment } from './types'
import { useMessageTabData } from './useMessageTabData'
import { ErrorVariant } from '@/Components/error/constants'
import { ErrorPage } from '@/Components/error/Errors'
import { useModalHandler } from '@/hooks/useModalHandler'

import './MessageTab.scss'

export const MessageTab: React.FC = connect(() => {
  const dataItem = useDataItem()
  const subjectId = dataItem?.id() ?? ''

  const { messages, loggedInUserId, error } = useMessageTabData({ subjectId })

  const { isOpen, openModal, closeModal } = useModalHandler()
  const [previewAttachment, setPreviewAttachment] =
    useState<MessageAttachment>()

  const listRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight
    }
  }, [messages.length])

  if (!subjectId) return
  if (error) return <ErrorPage variant={ErrorVariant.InternalServerError} />

  const onPreviewAttachment = (attachment: MessageAttachment) => {
    setPreviewAttachment(attachment)
    openModal()
  }

  return (
    <div className="message-tab">
      <div className="message-tab__list" ref={listRef}>
        {messages.map((message) => (
          <MessageListItem
            key={message.id()}
            message={message}
            loggedInUserId={loggedInUserId}
            onPreviewAttachment={onPreviewAttachment}
          />
        ))}
      </div>

      <div className="message-tab__composer-wrapper">
        <NewMessage subjectId={subjectId} />
      </div>

      <MessageAttachmentImageModal
        messageAttachment={previewAttachment}
        isOpen={isOpen}
        close={closeModal}
      />
    </div>
  )
})
